"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlTransactionStatusValidation = void 0;
const ChargingSessionAttemptIdWithPortValidation_1 = require("./ChargingSessionAttemptIdWithPortValidation");
class ChargerControlTransactionStatusValidation {
    static isValid(entity) {
        // Validate entity.failed_session_attempts for existence and correct type.
        if (entity.failed_session_attempts == undefined)
            return false;
        if (!Array.isArray(entity.failed_session_attempts))
            return false;
        if (!entity.failed_session_attempts.every((elem) => {
            if (!ChargingSessionAttemptIdWithPortValidation_1.ChargingSessionAttemptIdWithPortValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        // Validate entity.active_session_attempts for existence and correct type.
        if (entity.active_session_attempts == undefined)
            return false;
        if (!Array.isArray(entity.active_session_attempts))
            return false;
        if (!entity.active_session_attempts.every((elem) => {
            if (!ChargingSessionAttemptIdWithPortValidation_1.ChargingSessionAttemptIdWithPortValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargerControlTransactionStatusValidation = ChargerControlTransactionStatusValidation;
